/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![BrowserQuestionMarkIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABYUlEQVR4nO1UPUsDQRA9m6BgqYVYiGAjWAgBFfGjsRAv83HC3EzOIoU/xSb+DVt7C0uDvZViY6WxEEFULI3seRw5E4OXOxvxwcCyzL6382YYz/vHTyAiFWQ9BNI2snWKBLDeIVvTcaYC7qIoMfZGMxVIVDtEulrj+tqgM+aopLuC+NKREOn6oDPmiB6BssNLBUhbZZMD25n3dwBs56X3gLSVCgztM9mbm3eiaFFExnxfphENnf/I+lpIAEjbzDr/nSsiMl6sAgw33Fs/CBeQ9DSp5gZIDzYbjdGM2hDWXLt3QbA3BWSPfXKOigpcunc7u9EMkD0B63GtVp9AtGUge4lzQGaLWPTOXF/qY/0Ikl65HOao2rPscsYtBOFKykG6j2QnnyNq95k+DL2uyS5icpC51D62Z8Rw6+tIVZxI3kog6YX7rZt7ZH3YFpn0fgPMUTXje9mI1033eigbjrzfiv4AIgllHLzaxqIAAAAASUVORK5CYII=)
 */
export const BrowserQuestionMarkIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M1 6a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6Zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm2 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M1 12a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1v.56c0 .46-.61.7-1 .45-.92-.65-2.04-1.01-3.19-1.01-1.83 0-3.53.89-4.54 2.36a3 3 0 0 0 1.18 4.4c.23.1.38.35.37.6a3 3 0 0 0 .04.7l.07.35a.5.5 0 0 1-.5.59H4a3 3 0 0 1-3-3v-6Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M18.81 16c-.54 0-1 .26-1.23.61a1 1 0 0 1-1.66-1.12 3.49 3.49 0 0 1 2.9-1.49c1.81 0 3.43 1.38 3.43 3.25 0 1.45-.98 2.61-2.27 3.06a1 1 0 0 1-1.96.37l-.19-1a1 1 0 0 1 .98-1.18c.87 0 1.44-.63 1.44-1.25S19.68 16 18.81 16ZM20 23a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
        className={colorClass}
      />
    </svg>
  );
};
